import { StyledHeaderElement } from '../../../../styles/sharedStyles';
import { StyledText } from '../../../atoms/Text/StyledText';
import { StyledSummaryElementData } from '../../../atoms/SummaryEditElement/StyledSummaryElementData';
import { getDateString } from '../../../../logic/eventtime';
import Decimal from 'decimal.js';
import { useMemo, useState } from 'react';
import PaymentsPopup from '../../Payments/PaymentsPopup';

const SummaryEditElementManagerHourTable = ({ hour }) => {
    const [isOpenShowDescriptionModal, setIsOpenShowDescriptionModal] = useState(false);
    const price = useMemo(() => new Decimal(hour.price), [hour]);
    return (
        <>
            {isOpenShowDescriptionModal ? (
                <PaymentsPopup
                    title={hour.description}
                    onClose={() => {
                        setIsOpenShowDescriptionModal(false);
                    }}
                />
            ) : null}
            <StyledSummaryElementData>
                <StyledHeaderElement $hasDeclaredWidth="14.2%">
                    <StyledText
                        hasdeclaredfontsize="16px"
                        hasdeclaredfontweight="600"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                    >
                        {hour.type.name}
                    </StyledText>
                </StyledHeaderElement>
                <StyledHeaderElement $hasDeclaredWidth="14.2%">
                    <StyledText
                        hasdeclaredfontsize="16px"
                        hasdeclaredfontweight="600"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                    >
                        {getDateString(new Date(hour.date))}
                    </StyledText>
                </StyledHeaderElement>
                <StyledHeaderElement $hasDeclaredWidth="14.2%">
                    <StyledText
                        hasdeclaredfontsize="16px"
                        hasdeclaredfontweight="600"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                    >
                        {hour.hours}
                    </StyledText>
                </StyledHeaderElement>
                <StyledHeaderElement $hasDeclaredWidth="14.2%">
                    <StyledText
                        hasdeclaredfontsize="16px"
                        hasdeclaredfontweight="600"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                    >
                        {hour.manager.firstname} {hour.manager.lastname}
                    </StyledText>
                </StyledHeaderElement>
                <StyledHeaderElement $hasDeclaredWidth="14.2%">
                    <StyledText
                        hasdeclaredfontsize="16px"
                        hasdeclaredfontweight="600"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                    >
                        {price.dp() > 0 ? price.toFixed(2) : price.toString()} PLN
                    </StyledText>
                </StyledHeaderElement>
                <StyledHeaderElement $hasDeclaredWidth="14.2%">
                    <StyledText
                        hasdeclaredfontsize="16px"
                        hasdeclaredfontweight="600"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                        onClick={() =>
                            hour.description.length > 10 && setIsOpenShowDescriptionModal(true)
                        }
                        hascursor={hour.description.length > 10 ? 'pointer' : ''}
                    >
                        {hour.description.length > 10
                            ? hour.description.substring(0, 10) + '...'
                            : hour.description}
                    </StyledText>
                </StyledHeaderElement>
            </StyledSummaryElementData>
        </>
    );
};

export default SummaryEditElementManagerHourTable;
